import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import * as authActions from 'app/auth/store/actions';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  PersonAdd as PersonAddIcon,
  Lock as LockIcon,
  ExitToApp as ExitToAppIcon
} from '@material-ui/icons';
import { Typography, makeStyles, withStyles } from '@material-ui/core';
import { ProfilIcon } from 'app/main/components/icons';

const StyledMenuItem = withStyles(theme => ({
  root: {
    '& hover': {
      textDecoration: 'none'
    }
  }
}))(MenuItem);

const useStyles = makeStyles(theme => ({
  avatar: {
    width: 30,
    height: 30,
    position: 'relative',
    // padding   : 2,
    boxSizing: 'content-box',
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut
    }),
    '& > img': {
      objectFit: 'contain !important'
    }
  },
  button: {
    color: theme.palette.text.dynamic,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(4),
    '&:hover': {
      borderRadius: 5
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(0.5),
      marginRight: 0,
      '& .MuiButton-endIcon': {
        display: 'none'
      },
      '& .MuiButton-label': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      },
      '& .MuiButton-startIcon': {
        marginRight: 'initial'
      },
      '& .MuiSvgIcon-root': {
        marginRight: 'initial',
        width: 23,
        height: 23
      },
      [theme.breakpoints.down('xs')]: {
        minWidth: '50px !important',
        '& .MuiTypography-root': {
          display: 'none'
        }
      }
    }
  }
}));

function UserMenu(props) {
  const userFromLocalStorage = localStorage.getItem('user');
  const userLS = JSON.parse(userFromLocalStorage);
  const acceptCgu = userLS?.accept_cgu;
  // const acceptCgu = "2024-02-01 00:00:00";
  // owner is in the local storage during interpretation, meaning we don't want to show the TOU when an admin is emulating an other user
  const ownerFromLocalStorage = localStorage?.getItem('owner');
  const ownerLS = JSON.parse(ownerFromLocalStorage);
  const classes = useStyles();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(({ auth }) => auth.user);
  const [userMenu, setUserMenu] = useState(null);

  const userMenuClick = event => {
    setUserMenu(event.currentTarget);
  };

  const userMenuClose = () => {
    setUserMenu(null);
  };

  const cancelSwitch = () => {
    const owner = JSON.parse(localStorage.getItem('owner'));

    if (owner.access_token) {
      localStorage.setItem('jwt_access_token', owner.access_token);
      localStorage.setItem('user', JSON.stringify(owner));
      localStorage.removeItem('owner');

      if(user?.myGroup?.is_collaborator) {
        window.location = '/collaborators';
      } else {
        window.location = '/users';
      }
    }
  };

  return (
    <>
      <Button
        className={classes.button}
        startIcon={<ProfilIcon style={{ fontSize: 25 }} />}
        endIcon={<KeyboardArrowDownIcon variant="action" />}
        onClick={userMenuClick}
      >
        {user.brand && (
          <Avatar
            alt="user photo"
            className={clsx(classes.avatar, 'avatar')}
            color={
              user.brand[0].color_primary
                ? `#${user.brand[0].color_primary}`
                : '#D4B170'
            }
            src={`/assets/images/logos/${user.brand[0].code.toLowerCase()}.svg`}
          />
        )}
        <Typography
          component="span"
          style={{ fontSize: '1.5rem', fontFamily: 'sofia-pro' }}
        >
          {t('user.account')}
        </Typography>
      </Button>

      <Popover
        open={Boolean(userMenu)}
        anchorEl={userMenu}
        onClose={userMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        classes={{
          paper: 'py-8'
        }}
      >
        {!user.role || user.role.length === 0 ? (
          <>
            <MenuItem button component={Link} to="/login" role="button">
              <ListItemIcon className="min-w-40">
                <LockIcon />
              </ListItemIcon>
              <ListItemText primary={`${t('user.identify')}`} />
            </MenuItem>
          </>
        ) : (
          <>
            <StyledMenuItem
              component={Link}
              to={!acceptCgu ? '/terms' : '/profile'}
              onClick={() => userMenuClose()}
            >
              <ListItemIcon>
                <ProfilIcon />
              </ListItemIcon>
              <ListItemText primary={t('user.my_account')} />
            </StyledMenuItem>
            {localStorage.getItem('owner') ? (
              <MenuItem
                onClick={() => {
                  cancelSwitch();
                  userMenuClose();
                }}
              >
                <ListItemIcon>
                  <ExitToAppIcon />
                </ListItemIcon>
                <ListItemText primary={t('session.logout_switch')} />
              </MenuItem>
            ) : (
              <MenuItem
                onClick={() => {
                  dispatch(authActions.logoutUser());
                  userMenuClose();
                }}
              >
                <ListItemIcon>
                  <ExitToAppIcon />
                </ListItemIcon>
                <ListItemText primary={t('session.logout')} />
              </MenuItem>
            )}
          </>
        )}
      </Popover>
    </>
  );
}

export default UserMenu;
